import { ClientInput } from "../../shared/interfaces";
import { clientInputKeys } from "../../config/constants";

export const validateClientInputs = (clientInput : ClientInput) => {
    const hasTrackingId = !!clientInput.trackingId;
    const hasIndexableAttributes = !!clientInput.identifierType && !!clientInput.identifierValue;

    // Exactly one lookup method must be provided: either trackingId or identifierType+identifierValue
    if ((!hasTrackingId && !hasIndexableAttributes) || (hasTrackingId && hasIndexableAttributes)) {
        return false;
    }

    clientInputKeys.forEach(({ key, optional, validationFunction }) => {
        if (!optional && !clientInput[key]) {
            return false;
        }
        if (validationFunction && !validationFunction(clientInput[key])) {
            return false;
        }
    });
    return true;
};
